export enum RoutesSalesEnum {
  LIST = '/vendas',
  CREATE = '/vendas',
  HISTORY = '/vendas/historico',
  EDIT = '/vendas/:id/editar',
  DETAILS = '/vendas/:id/detalhes'
}
